// helpers related to email to cleanup pi1.jsx length
// note that the exported fns are NOT pure and require binding to the correct
// this context (ie pi1 instance), thus they are not arrow fns on purpose!
// when converted to redux, can change these to thunks
import axios from 'lc-http';
import { trackHeapEvent } from '../../../shared_modules/custom-heap-tracking-attributes/custom-heap-tracking-attributes';
import { exp } from '../serverContext';

// TODO after researching this feature, it doesn't work- do we still need it?
// TODO remove if PBS no longer returns these from checkemail endpoint (and
// only LOAN_APP_IN_PROGRESS)
// is the submitAttempts password inline error still a feature? if so, need to
// file a bug that it isn't working (in demo too). originally added for RUE v1,
// seems to have been productized, but unsure
const ERROR_CODE_MESSAGES = {
  DONT_SHARE_EMAIL: {
    // old actor does not have login (??)
    msg: 'This email is associated with another account. Use a new one.',
    field: 'email',
  },
  EMAIL_TAKEN: {
    // user has small biz acct
    msg: 'This email is associated with another account. Use a new one.',
    field: 'email',
  },
  DUPLICATE_EMAIL_WRONG_PASSWORD: {
    // confirmed with pbs this is no longer sent by checkEmail endpoint.
    msg: 'Don’t remember your password?',
    field: 'password',
  },
};

const parseEmailPasswordErrors = (errors, submitAttempts) => {
  if (submitAttempts > 1) {
    ERROR_CODE_MESSAGES.password.DUPLICATE_EMAIL_WRONG_PASSWORD = 'Reset your password to get your offer faster.'; // this does not work due to the above
  }

  return errors.reduce((errorsByField, err) => {
    const errKey = typeof err === 'string' ? err : err.error;
    const entry = ERROR_CODE_MESSAGES[errKey];
    if (entry) {
      // can only be 1 error per field, else would need to merge
      errorsByField[entry.field] = { [errKey]: entry.msg };
    }
    return errorsByField;
  }, {});
};

// for heap tracking.
const getEmailErrorsArray = emailErrors =>
  emailErrors &&
  Object.keys(emailErrors).map(errKey => ({
    error: errKey,
    message: emailErrors[errKey],
  }));

export const captureEmail = function (email) {
  const userData = {
    firstName: this.state.fields.primary.name.firstName,
    lastName: this.state.fields.primary.name.lastName,
    queryParams: window.location.search,
  };
  axios({
    method: 'POST',
    url: '/apply/personal/identity/capture-email',
    data: {
      email,
      userData,
    },
  }).catch(() => {
    // do nothing
  });
};

export const checkEmail = function (email) {
  return axios({
    method: 'POST',
    url: '/apply/personal/identity/check-email',
    data: {
      email,
      primaryDOB: this.state.fields.primary.dob,
    },
  })
    .then(response => {
      // handle response here, eg. { errors: ["LOAN_APP_IN_PROGRESS"], authenticationRequired: true } or maybe a email validation error

      const parsedEmailPasswordErrors =
        response.data.errors && parseEmailPasswordErrors(response.data.errors, this.state.submitAttempt);
      const heapTrackData = {
        borrowerStatus: response.data.authenticationRequired ? 'Return User' : 'New User',
        checkEmailErrors: response.data.errors && response.data.errors[0],
        exp,
      };
      trackHeapEvent('PL Funnel - RUE v2', 'checkEmail', heapTrackData);
      // could potentially make this a pure fn/not dependent on setState by
      // returning the result as well as the emailErrorsArray, then setState in
      // pi1
      this.setState({
        checkEmailErrors: response.data.errors,
        isAuthenticationRequired: response.data.authenticationRequired,
        parsedEmailPasswordErrors,
      });

      return getEmailErrorsArray(parsedEmailPasswordErrors.email);
    })
    .catch(() => {});
  // swallow for now, let user move on
  // handle error here, normally a 500, 502 or timeout from BAUI. else can
  // remove this catch
};

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pi1-1QAAT.scss');